import moment from 'moment';

export default {

    date(val, format = 'MMM D, Y') {
        return val ? moment.unix(val).format(format) : '';
    },

    dateTime(val, format = 'MMM D, Y h:mm A') {
        return val ? moment.unix(val).format(format) : '';
    },

    relativeTime(val, withoutSuffix = false) {
        return val ? moment.unix(val).fromNow(withoutSuffix) : '';
    },

}